import createActionConstants from 'lib/create-action-constants'

export const constants = createActionConstants('dashboard', [
  'FETCH_DASHBOARD',
  'FETCH_DASHBOARD_SUCCESS',
  'FETCH_DASHBOARD_FAILURE',
  'FETCH_DASHBOARD_FORBIDDEN',

  'FLUSH_DASHBOARD',

  'EDIT_CUSTOM_DASHBOARD',
  'EDIT_CUSTOM_DASHBOARD_SUCCESS',
  'EDIT_CUSTOM_DASHBOARD_FAILURE',

  'DELETE_CUSTOM_DASHBOARD',
  'DELETE_CUSTOM_DASHBOARD_SUCCESS',
  'DELETE_CUSTOM_DASHBOARD_FAILURE',

  'EXPORT_DASHBOARD',
  'EXPORT_DASHBOARD_SUCCESS',
  'EXPORT_DASHBOARD_FAILURE'
])

export const fetchDashboard = (slug, type, headers) => ({
  type: constants.FETCH_DASHBOARD,
  payload: {
    slug,
    type,
    headers
  }
})

export const flushDashboard = () => ({
  type: constants.FLUSH_DASHBOARD
})

export const deleteCustomDashboard = (dashboardSlug, userSlug, history) => ({
  type: constants.DELETE_CUSTOM_DASHBOARD,
  payload: {
    dashboardSlug,
    userSlug,
    history
  }
})

export const exportDashboard = opts => ({
  type: constants.EXPORT_DASHBOARD,
  payload: opts
})
